// Site configuration constants
export const SITE_CONFIG = {
  domain: {
    name: 'international-intelligence.org',
    displayName: 'International Intelligence',
    tld: '.org',
    fullName: 'international-intelligence.org',
  },
  owner: {
    name: 'Bronz Yazılım',
    email: 'mail@bronzyazilim.com',
    description: 'Turkish software company',
  },
  contact: {
    email: 'mail@bronzyazilim.com',
  },
  seo: {
    title: 'International-Intelligence.org | Premium Domain For Sale',
    description: 'Premium domain international-intelligence.org is available for acquisition. Perfect for intelligence agencies, consulting firms, AI companies, research organizations. Owned by Bronz Yazılım, Turkey.',
    keywords: 'international intelligence domain, premium domain sale, intelligence agency domain, consulting firm domain, AI company domain, domain for sale',
    canonicalUrl: 'https://international-intelligence.org/',
  },
} as const;
